import { fadeInHeightExpandTransition as t } from "../../../_styles/transitions/fade-in-height-expand.cssr.js";
import { iconSwitchTransition as a } from "../../../_styles/transitions/icon-switch.cssr.js";
import { c as r, cB as e, cE as i, cM as o } from "../../../_utils/cssr/index.js";
const f = r([e("message-wrapper", `
 margin: var(--n-margin);
 z-index: 0;
 transform-origin: top center;
 display: flex;
 `, [t({
  overflow: "visible",
  originalTransition: "transform .3s var(--n-bezier)",
  enterToProps: {
    transform: "scale(1)"
  },
  leaveToProps: {
    transform: "scale(0.85)"
  }
})]), e("message", `
 box-sizing: border-box;
 display: flex;
 align-items: center;
 transition:
 color .3s var(--n-bezier),
 box-shadow .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 opacity .3s var(--n-bezier),
 transform .3s var(--n-bezier),
 margin-bottom .3s var(--n-bezier);
 padding: var(--n-padding);
 border-radius: var(--n-border-radius);
 flex-wrap: nowrap;
 overflow: hidden;
 max-width: var(--n-max-width);
 color: var(--n-text-color);
 background-color: var(--n-color);
 box-shadow: var(--n-box-shadow);
 `, [i("content", `
 display: inline-block;
 line-height: var(--n-line-height);
 font-size: var(--n-font-size);
 `), i("icon", `
 position: relative;
 margin: var(--n-icon-margin);
 height: var(--n-icon-size);
 width: var(--n-icon-size);
 font-size: var(--n-icon-size);
 flex-shrink: 0;
 `, [["default", "info", "success", "warning", "error", "loading"].map((n) => o(`${n}-type`, [r("> *", `
 color: var(--n-icon-color-${n});
 transition: color .3s var(--n-bezier);
 `)])), r("> *", `
 position: absolute;
 left: 0;
 top: 0;
 right: 0;
 bottom: 0;
 `, [a()])]), i("close", `
 margin: var(--n-close-margin);
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 flex-shrink: 0;
 `, [r("&:hover", `
 color: var(--n-close-icon-color-hover);
 `), r("&:active", `
 color: var(--n-close-icon-color-pressed);
 `)])]), e("message-container", `
 z-index: 6000;
 position: fixed;
 height: 0;
 overflow: visible;
 display: flex;
 flex-direction: column;
 align-items: center;
 `, [o("top", `
 top: 12px;
 left: 0;
 right: 0;
 `), o("top-left", `
 top: 12px;
 left: 12px;
 right: 0;
 align-items: flex-start;
 `), o("top-right", `
 top: 12px;
 left: 0;
 right: 12px;
 align-items: flex-end;
 `), o("bottom", `
 bottom: 4px;
 left: 0;
 right: 0;
 justify-content: flex-end;
 `), o("bottom-left", `
 bottom: 4px;
 left: 12px;
 right: 0;
 justify-content: flex-end;
 align-items: flex-start;
 `), o("bottom-right", `
 bottom: 4px;
 left: 0;
 right: 12px;
 justify-content: flex-end;
 align-items: flex-end;
 `)])]);
export {
  f as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/message/src/styles/index.cssr.js
// module id = 1672
// module chunks = 41